<template>
  <div class="mb-4">
    <label class="titlePage">Tratamento - Colégios</label>
    <div class="row mt-4">
      <div class="col-4">
        <fcc-select
          class="mr-2"
          label-field="cidadeprova"
          value-field="codcidexame"
          v-model="idCidadeDeProva"
          :options="cidades"
          :clearable="false"
          required
          >Cidade de Prova</fcc-select
        >
      </div>

      <div class="col-4">
        <fcc-select
          class="mr-2"
          label-field="periodo"
          value-field="iddatacidade"
          v-model="periodo"
          :options="periodos"
          :clearable="false"
          required
          :disabled="!idCidadeDeProva"
          >Período</fcc-select
        >
      </div>

      <div class="col">
        <fccButton @click="buscar" :disabled="idCidadeDeProva === null">{{
          labelsSystem.buscar
        }}</fccButton>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../../../../store'

export default {
  props: ['cidadesDeProva'],
  data() {
    return {
      idCidadeDeProva: null,
      periodo: null
    }
  },
  methods: {
    buscar() {
      this.$emit('buscar', this.periodo)
    }
  },
  computed: {
    configuracao() {
      return store.state.localDeProva.configuracao
    },
    cidades() {
      return (
        this.cidadesDeProva &&
        this.cidadesDeProva.reduce((acc, curr, idx) => {
          if (idx === 0) return [curr]
          else {
            if (acc[acc.length - 1].codcidexame === curr.codcidexame) return acc
            else return [...acc, curr]
          }
        }, [])
      )
    },
    periodos() {
      return this.cidadesDeProva.filter((item) => item.codcidexame === this.idCidadeDeProva)
    }
  },
  watch: {
    configuracao() {
      this.idCidadeDeProva = null
    },
    idCidadeDeProva() {
      this.periodo = null
    }
  }
}
</script>